import { Component, Inject, signal } from '@angular/core';
import { ToastController } from '@gruposaltaedu/liv-design-system/components';
import { I18nService } from '@gruposaltaedu/liv-i18n/core';
import { MODAL_DATA } from 'src/app/ui/components/modal/modal.component';
import { ModalService } from 'src/app/ui/components/modal/modal.service';

export interface CopyVideoLinkModalData {
  linkToCopy: string;
}

@Component({
  selector: 'liv-copy-link-modal',
  templateUrl: './copy-link-modal.component.html',
  styleUrls: ['./copy-link-modal.component.scss'],
  standalone: false
})
export class CopyLinkModalComponent {
  title = 'buttons.copy_link';
  readonly linkToCopy = signal<string>('');

  constructor(
    @Inject(MODAL_DATA) private data: CopyVideoLinkModalData,
    private modal: ModalService,
    private toastService: ToastController,
    private language: I18nService
  ) {
    if (this.data) {
      this.linkToCopy.set(this.data.linkToCopy);
    }
  }

  async handleCopyLink(value: string): Promise<void> {
    await navigator.clipboard.writeText(value);
    this.toastService.success({
      message: this.language.instant('messages.copied_link')
    });
  }

  onClose(): void {
    this.modal.close();
  }
}
